import FormattedDateTime from 'I18n/components/FormattedDateTime';
//@ts-expect-error FormattedDuration does not have a TS implementation.
import FormattedDuration from 'I18n/components/FormattedDuration';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { dueDateBreached, getIsDueInLessThanEightHours, getIsDueTomorrow, isDueToday } from '../operators/dueDateComparators';
import { useCurrentTime } from '../hooks/useCurrentTime';
import { jsx as _jsx } from "react/jsx-runtime";
const SLADetailsTime = ({
  dueDate
}) => {
  const {
    currentTime
  } = SLADetailsTime.useComponent(100);
  if (dueDateBreached(currentTime, dueDate)) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.pastDueBy",
      options: {
        time: /*#__PURE__*/_jsx(FormattedDuration, {
          from: dueDate,
          format: "medium",
          combined: true
        })
      }
    });
  }
  const dueDateObject = new Date(dueDate);
  if (getIsDueTomorrow(currentTime, dueDateObject)) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.tommorrowByTime",
      options: {
        time: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "LT",
          value: dueDate
        })
      }
    });
  }
  if (getIsDueInLessThanEightHours(dueDate, currentTime)) {
    return /*#__PURE__*/_jsx(FormattedDuration, {
      to: dueDate,
      format: "medium",
      combined: true
    });
  }
  if (isDueToday(currentTime, dueDateObject)) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.byTime",
      options: {
        timeOrDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "LT",
          value: dueDate
        })
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedDateTime, {
    format: "llll",
    value: dueDate
  });
};
SLADetailsTime.useComponent = useCurrentTime;
SLADetailsTime.displayName = 'SLADetailsTime';
export default SLADetailsTime;